import React from 'react';
import { Plus, User } from 'lucide-react';

const TimetableCell = ({ slot, slotType, onClick, readOnly = false }) => {
  // If break or lunch slot, render non-assignable divider
  if (slotType === 'SHORT_BREAK' || slotType === 'LUNCH') {
    return (
      <div style={{ padding: '12px 8px', background: '#F1F5F9', border: '1px solid #E2E8F0', borderRadius: '8px', textAlign: 'center', height: '100%', minHeight: '64px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ fontSize: '11.5px', fontWeight: '800', color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          {slotType === 'LUNCH' ? '☕ LUNCH BREAK' : '☕ SHORT BREAK'}
        </span>
      </div>
    );
  }

  // Assigned teaching slot
  if (slot && slot.subject) {
    return (
      <div 
        onClick={readOnly ? undefined : onClick}
        style={{
          padding: '10px 12px',
          background: 'white',
          border: '1.5px solid #BFDBFE',
          borderRadius: '10px',
          cursor: readOnly ? 'default' : 'pointer',
          boxShadow: '0 2px 4px rgba(37, 99, 235, 0.06)',
          transition: 'all 0.15s ease',
          height: '100%',
          minHeight: '64px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
        className={readOnly ? '' : 'hover-cell'}
      >
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <span style={{ fontSize: '13.5px', fontWeight: '800', color: '#0F172A', lineHeight: '1.2' }}>
              {slot.subject}
            </span>
            {slot.subjectCode && (
              <span style={{ fontFamily: 'monospace', fontSize: '10.5px', fontWeight: '700', backgroundColor: '#EFF6FF', color: '#2563EB', padding: '2px 6px', borderRadius: '4px' }}>
                {slot.subjectCode}
              </span>
            )}
          </div>

          <div style={{ fontSize: '12px', color: '#475569', fontWeight: '600', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <User size={13} color="#64748B" /> {slot.teacher || 'Unassigned'}
          </div>
        </div>
      </div>
    );
  }

  // Empty assignable slot
  return (
    <div 
      onClick={readOnly ? undefined : onClick}
      style={{
        padding: '10px 8px',
        background: readOnly ? '#FAFAFA' : '#F8FAFC',
        border: readOnly ? '1px solid #E2E8F0' : '1.5px dashed #93C5FD',
        borderRadius: '10px',
        cursor: readOnly ? 'default' : 'pointer',
        height: '100%',
        minHeight: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.15s ease',
        textAlign: 'center'
      }}
      className={readOnly ? '' : 'hover-empty-cell'}
    >
      {!readOnly ? (
        <span style={{ fontSize: '11.5px', fontWeight: '700', color: '#2563EB', display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Plus size={14} color="#2563EB" /> Click to Assign Subject
        </span>
      ) : (
        <span style={{ fontSize: '12px', fontWeight: '500', color: '#94A3B8' }}>
          —
        </span>
      )}
    </div>
  );
};

export default TimetableCell;
